import React, {useState, useContext} from 'react';
import { useLocation } from 'react-router-dom';
import './FeedbackForm.scss';
import {I18nContext} from '../../contexts/i18nContext';
import {FeedbackContext} from '../../contexts/feedbackContext';
import {Button, TextInput} from '../_common';
import {getCurrentUserData} from "../../helpers/helpers";

const FeedbackForm = ({secondaryButtonAction}) => {
  const { t } = useContext(I18nContext);
  const {
    addFeedbackPending,
    addFeedback,
    getFeedback,
    error,
  } = useContext(FeedbackContext);
  const user = getCurrentUserData();
  const location = useLocation();

  const [formValues, setFormValues] = useState({
    title: "",
    text: "",
    localDateTime: new Date(),
    userId: user.id,
    email: user.email,
    userLocation: location.pathname
  });

  const changeValue = (name, value) => {
    const newValues = {...formValues};
    newValues[name] = value;
    setFormValues(newValues);
  };

  const addNewFeedback = async () => {
    const newFeedback = await addFeedback(formValues);
    await getFeedback();
    secondaryButtonAction();
  };

  const formHasEmptyFields = () => {
    const emptyInputs = Object.values(formValues).filter(item => !item);
    return !!emptyInputs.length;
  };

  return (
    <form className='FeedbackForm'>
      <div className='formInputs'>
        <TextInput
          label={t('subject')}
          required
          name='title'
          onChange={changeValue}
          value={formValues.title}
        />
        <TextInput
          label={t('comment')}
          required
          name='text'
          onChange={changeValue}
          value={formValues.text}
          area
        />
      </div>
      <div className='formButtons'>
        <Button type='secondary' action={secondaryButtonAction} label={t('cancel')} />
        <Button
          type='primary'
          action={addNewFeedback}
          label={t('send feedback')}
          margin='left'
          disabled={formHasEmptyFields() || addFeedbackPending}
          pending={addFeedbackPending}
        />
      </div>
    </form>
  );
};

export default FeedbackForm;
